<template>
  <div>
    <!-- <p class="ml-3">stop Interval : {{this.breakInterval}}</p> -->
    <!-- <br> -->
    <!-- <vs-button @click="openPopupErrorTask()">alert</vs-button> -->
    <vs-row>
      <vs-col vs-sm="12" vs-xs="12" vs-lg="7">
        <vs-card style="border-radius: 15px; padding-left: 5; height: 97%">
          <div style="position: relative">
            <img
              src="@/assets/images/mapfarm1.jpeg"
              width="650"
              height="400"
              align="center"
              style="width: 100%; height: auto"
              class="mt-3"
            />
            <img
              v-if="statusTank === 'off'"
              src="@/assets/images/tankOff.gif"
              id="tankOff"
              style="
                position: absolute;
                left: 61%;
                top: 30%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusTank === 'on'"
              src="@/assets/images/tankOn.gif"
              id="tankOn"
              style="
                position: absolute;
                left: 61%;
                top: 30%;
                width: 10%;
                height: auto;
              "
            />
            <b-tooltip
              target="tankOff"
              triggers="hover"
              v-if="statusTank === 'off'"
            >
              <vs-row>
                <b>Water Tank </b>
              </vs-row>
              <vs-row class="mt-2">
                <b>Status : Low </b>
              </vs-row>
              <vs-row class="mt-1"></vs-row>
            </b-tooltip>
            <b-tooltip
              target="tankOn"
              triggers="hover"
              v-if="statusTank === 'on'"
            >
              <vs-row>
                <b>Water Tank </b>
              </vs-row>
              <vs-row class="mt-2">
                <b>Status : Full </b>
              </vs-row>
              <vs-row class="mt-2"></vs-row>
            </b-tooltip>
            <img
              v-if="statusValve1 === false"
              src="@/assets/images/valveOff.gif"
              id="valve1Off"
              style="
                position: absolute;
                left: 5%;
                top: 70%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusValve1 === true"
              src="@/assets/images/valveOn.gif"
              id="valve1On"
              style="
                position: absolute;
                left: 5%;
                top: 70%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusValve1 == 'pending'"
              src="@/assets/images/pending.gif"
              id="valve1Pending"
              style="
                position: absolute;
                left: 5%;
                top: 70%;
                width: 10%;
                height: auto;
              "
            />
            <b-tooltip
              target="valve1Off"
              triggers="hover"
              v-if="statusValve1 === false"
            >
              <vs-row>
                <b>Valve1</b>
              </vs-row>
              <vs-row>
                <b
                  >Status :
                  <toggle-button
                    v-model="statusValve1"
                    @change="onOffValve('statusValve1')"
                    class="mt-2"
                    color="#32c040"
                    align="center"
                    width="35"
                    height="20"
                /></b>
              </vs-row>
            </b-tooltip>
            <b-tooltip
              target="valve1On"
              triggers="hover"
              v-if="statusValve1 === true"
            >
              <vs-row>
                <b>Valve1</b>
              </vs-row>
              <vs-row>
                <b
                  >Status :
                  <toggle-button
                    v-model="statusValve1"
                    @change="onOffValve((temp = 'statusValve1'))"
                    class="mt-2"
                    color="#32c040"
                    align="center"
                    width="35"
                    height="20"
                /></b>
              </vs-row>
            </b-tooltip>
            <b-tooltip
              target="valve1Pending"
              triggers="hover"
              v-if="statusValve1 == 'pending'"
            >
              <vs-row>
                <b>Valve1</b>
              </vs-row>
              <vs-row>
                <b>Status : Pending </b>
              </vs-row>
            </b-tooltip>
            <img
              v-if="statusValve2 === false"
              src="@/assets/images/valveOff.gif"
              id="valve2Off"
              style="
                position: absolute;
                left: 30%;
                top: 70%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusValve2 === true"
              src="@/assets/images/valveOn.gif"
              id="valve2On"
              style="
                position: absolute;
                left: 30%;
                top: 70%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusValve2 == 'pending'"
              src="@/assets/images/pending.gif"
              id="valve2Pending"
              style="
                position: absolute;
                left: 30%;
                top: 70%;
                width: 10%;
                height: auto;
              "
            />
            <b-tooltip
              target="valve2Off"
              triggers="hover"
              v-if="statusValve2 === false"
            >
              <vs-row>
                <b>Valve2</b>
              </vs-row>
              <vs-row>
                <b
                  >Status :
                  <toggle-button
                    v-model="statusValve2"
                    @change="onOffValve((temp = 'statusValve2'))"
                    class="mt-2"
                    color="#32c040"
                    align="center"
                    width="35"
                    height="20"
                /></b>
              </vs-row>
            </b-tooltip>
            <b-tooltip
              target="valve2On"
              triggers="hover"
              v-if="statusValve2 === true"
            >
              <vs-row>
                <b>Valve2</b>
              </vs-row>
              <vs-row>
                <b
                  >Status :
                  <toggle-button
                    v-model="statusValve2"
                    @change="onOffValve((temp = 'statusValve2'))"
                    class="mt-2"
                    color="#32c040"
                    align="center"
                    width="35"
                    height="20"
                /></b>
              </vs-row>
            </b-tooltip>
            <b-tooltip
              target="valve2Pending"
              triggers="hover"
              v-if="statusValve2 == 'pending'"
            >
              <vs-row>
                <b>Valve2</b>
              </vs-row>
              <vs-row>
                <b>Status : Pending </b>
              </vs-row>
            </b-tooltip>
            <img
              v-if="statusValve3 === false"
              src="@/assets/images/valveOff.gif"
              id="valve3Off"
              style="
                position: absolute;
                left: 55%;
                top: 60%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusValve3 === true"
              src="@/assets/images/valveOn.gif"
              id="valve3On"
              style="
                position: absolute;
                left: 55%;
                top: 60%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusValve3 == 'pending'"
              src="@/assets/images/pending.gif"
              id="valve3Pending"
              style="
                position: absolute;
                left: 55%;
                top: 60%;
                width: 10%;
                height: auto;
              "
            />
            <b-tooltip
              target="valve3Off"
              triggers="hover"
              v-if="statusValve3 === false"
            >
              <vs-row>
                <b>Valve3</b>
              </vs-row>
              <vs-row>
                <b
                  >Status :
                  <toggle-button
                    v-model="statusValve3"
                    @change="onOffValve((temp = 'statusValve3'))"
                    class="mt-2"
                    color="#32c040"
                    align="center"
                    width="35"
                    height="20"
                /></b>
              </vs-row>
            </b-tooltip>
            <b-tooltip
              target="valve3On"
              triggers="hover"
              v-if="statusValve3 === true"
            >
              <vs-row>
                <b>Valve3</b>
              </vs-row>
              <vs-row>
                <b
                  >Status :
                  <toggle-button
                    v-model="statusValve3"
                    @change="onOffValve((temp = 'statusValve3'))"
                    class="mt-2"
                    color="#32c040"
                    align="center"
                    width="35"
                    height="20"
                /></b>
              </vs-row>
            </b-tooltip>
            <b-tooltip
              target="valve3Pending"
              triggers="hover"
              v-if="statusValve3 == 'pending'"
            >
              <vs-row>
                <b>Valve3</b>
              </vs-row>
              <vs-row>
                <b>Status : Pending </b>
              </vs-row>
            </b-tooltip>
            <img
              v-if="statusValve4 === false"
              src="@/assets/images/valveOff.gif"
              id="valve4Off"
              style="
                position: absolute;
                left: 5%;
                top: 45%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusValve4 === true"
              src="@/assets/images/valveOn.gif"
              id="valve4On"
              style="
                position: absolute;
                left: 5%;
                top: 45%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusValve4 == 'pending'"
              src="@/assets/images/pending.gif"
              id="valve4Pending"
              style="
                position: absolute;
                left: 5%;
                top: 45%;
                width: 10%;
                height: auto;
              "
            />
            <b-tooltip
              target="valve4Off"
              triggers="hover"
              v-if="statusValve4 === false"
            >
              <vs-row>
                <b>Valve4</b>
              </vs-row>
              <vs-row>
                <b
                  >Status :
                  <toggle-button
                    v-model="statusValve4"
                    @change="onOffValve((temp = 'statusValve4'))"
                    class="mt-2"
                    color="#32c040"
                    align="center"
                    width="35"
                    height="20"
                /></b>
              </vs-row>
            </b-tooltip>
            <b-tooltip
              target="valve4On"
              triggers="hover"
              v-if="statusValve4 === true"
            >
              <vs-row>
                <b>Valve4</b>
              </vs-row>
              <vs-row>
                <b
                  >Status :
                  <toggle-button
                    v-model="statusValve4"
                    @change="onOffValve((temp = 'statusValve4'))"
                    class="mt-2"
                    color="#32c040"
                    align="center"
                    width="35"
                    height="20"
                /></b>
              </vs-row>
            </b-tooltip>
            <b-tooltip
              target="valve4Pending"
              triggers="hover"
              v-if="statusValve4 == 'pending'"
            >
              <vs-row>
                <b>Valve4</b>
              </vs-row>
              <vs-row>
                <b>Status : Pending </b>
              </vs-row>
            </b-tooltip>
            <img
              v-if="statusValve5 === false"
              src="@/assets/images/valveOff.gif"
              id="valve5Off"
              style="
                position: absolute;
                left: 45%;
                top: 45%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusValve5 === true"
              src="@/assets/images/valveOn.gif"
              id="valve5On"
              style="
                position: absolute;
                left: 45%;
                top: 45%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusValve5 == 'pending'"
              src="@/assets/images/pending.gif"
              id="valve5Pending"
              style="
                position: absolute;
                left: 45%;
                top: 45%;
                width: 10%;
                height: auto;
              "
            />
            <b-tooltip
              target="valve5Off"
              triggers="hover"
              v-if="statusValve5 === false"
            >
              <vs-row>
                <b>Valve5</b>
              </vs-row>
              <vs-row>
                <b
                  >Status :
                  <toggle-button
                    v-model="statusValve5"
                    @change="onOffValve((temp = 'statusValve5'))"
                    class="mt-2"
                    color="#32c040"
                    align="center"
                    width="35"
                    height="20"
                /></b>
              </vs-row>
            </b-tooltip>
            <b-tooltip
              target="valve5On"
              triggers="hover"
              v-if="statusValve5 === true"
            >
              <vs-row>
                <b>Valve5</b>
              </vs-row>
              <vs-row>
                <b
                  >Status :
                  <toggle-button
                    v-model="statusValve5"
                    @change="onOffValve((temp = 'statusValve5'))"
                    class="mt-2"
                    color="#32c040"
                    align="center"
                    width="35"
                    height="20"
                /></b>
              </vs-row>
            </b-tooltip>
            <b-tooltip
              target="valve5Pending"
              triggers="hover"
              v-if="statusValve5 == 'pending'"
            >
              <vs-row>
                <b>Valve5</b>
              </vs-row>
              <vs-row>
                <b>Status : Pending </b>
              </vs-row>
            </b-tooltip>
            <img
              v-if="statusValve6 === false"
              src="@/assets/images/valveOff.gif"
              id="valve6Off"
              style="
                position: absolute;
                left: 77%;
                top: 14%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusValve6 === true"
              src="@/assets/images/valveOn.gif"
              id="valve6On"
              style="
                position: absolute;
                left: 77%;
                top: 14%;
                width: 10%;
                height: auto;
              "
            />
            <img
              v-if="statusValve6 == 'pending'"
              src="@/assets/images/pending.gif"
              id="valve6Pending"
              style="
                position: absolute;
                left: 77%;
                top: 14%;
                width: 10%;
                height: auto;
              "
            />
            <b-tooltip
              target="valve6Off"
              triggers="hover"
              v-if="statusValve6 === false"
            >
              <vs-row>
                <b>Valve6</b>
              </vs-row>
              <vs-row>
                <b
                  >Status :
                  <toggle-button
                    v-model="statusValve6"
                    @change="onOffValve((temp = 'statusValve6'))"
                    class="mt-2"
                    color="#32c040"
                    align="center"
                    width="35"
                    height="20"
                /></b>
              </vs-row>
            </b-tooltip>
            <b-tooltip
              target="valve6On"
              triggers="hover"
              v-if="statusValve6 === true"
            >
              <vs-row>
                <b>Valve6</b>
              </vs-row>
              <vs-row>
                <b
                  >Status :
                  <toggle-button
                    v-model="statusValve6"
                    @change="onOffValve((temp = 'statusValve6'))"
                    class="mt-2"
                    color="#32c040"
                    align="center"
                    width="35"
                    height="20"
                /></b>
              </vs-row>
            </b-tooltip>
            <b-tooltip
              target="valve6Pending"
              triggers="hover"
              v-if="statusValve6 == 'pending'"
            >
              <vs-row>
                <b>Valve6</b>
              </vs-row>
              <vs-row>
                <b>Status : Pending </b>
              </vs-row>
            </b-tooltip>
            <img
              src="@/assets/images/soilsensor.gif"
              id="soil1"
              style="
                position: absolute;
                left: 15%;
                top: 80%;
                width: 10%;
                height: auto;
              "
            />
            <b-tooltip target="soil1" triggers="hover">
              <vs-row>
                <b>Soil sensor 1</b>
              </vs-row>
              <vs-row>
                <b>Moisture : {{ this.soilMoistureCurrent1 }}%</b>
              </vs-row>
              <vs-row>
                <b>Temperature : {{ this.soilTempCurrent1 }}C</b>
              </vs-row>
              <vs-row>
                <b>EC : {{ this.soilEcCurrent1 }} ds/m</b>
              </vs-row>
            </b-tooltip>
            <img
              src="@/assets/images/soilsensor.gif"
              id="soil2"
              style="
                position: absolute;
                left: 28%;
                top: 45%;
                width: 10%;
                height: auto;
              "
            />
            <b-tooltip target="soil2" triggers="hover">
              <vs-row>
                <b>Soil sensor 2</b>
              </vs-row>
              <vs-row>
                <b>Moisture : {{ this.soilMoistureCurrent2 }}%</b>
              </vs-row>
              <vs-row>
                <b>Temperature : {{ this.soilTempCurrent2 }}C</b>
              </vs-row>
              <vs-row>
                <b>EC : {{ this.soilEcCurrent2 }} ds/m</b>
              </vs-row>
            </b-tooltip>
            <img
              src="@/assets/images/soilsensor.gif"
              id="soil3"
              style="
                position: absolute;
                left: 87%;
                top: 14%;
                width: 10%;
                height: auto;
              "
            />
            <b-tooltip target="soil3" triggers="hover">
              <vs-row>
                <b>Soil sensor 3</b>
              </vs-row>
              <vs-row>
                <b>Moisture : {{ this.soilMoistureCurrent3 }}%</b>
              </vs-row>
              <vs-row>
                <b>Temperature : {{ this.soilTempCurrent3 }}C</b>
              </vs-row>
              <vs-row>
                <b>EC : {{ this.soilEcCurrent1 }} ds/m</b>
              </vs-row>
            </b-tooltip>
          </div>
        </vs-card>
      </vs-col>
      <vs-col vs-sm="12" vs-xs="12" vs-lg="5">
        <!-- <vs-card style="border-radius: 15px; height: 97%"> -->
        <itemmap />
        <!-- </vs-card> -->
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-w="12" v-if="data.length !== 0">
        <div>
          <vs-card style="border-radius: 20px">
            <vs-row id="center">
              <vs-list-header
                title="Tasks List"
                style="font-size: 18px"
                color="dark"
              ></vs-list-header>
              <vs-spacer />
              <vs-button
                radius
                v-b-modal.modal-xl
                color="#4caf50"
                type="filled"
                @click="openLogTask"
                icon="view_comfy"
                align="right"
              ></vs-button>
              <vs-button
                radius
                color="#4caf50"
                type="filled"
                @click="addTask"
                icon="playlist_add"
                align="right"
                class="ml-2"
              ></vs-button>
            </vs-row>

            <vs-table :data="data" max-items="8" pagination search>
              <template slot="thead">
                <vs-th> Action </vs-th>
                <vs-th sortKey="task" style="padding: 0px"> Task </vs-th>
                <vs-th sortKey="sensor_id" style="padding: 0px"> Sensor </vs-th>
                <vs-th
                  sortKey="condition.min"
                  style="padding: 0px"
                  v-if="data[0].condition.min"
                >
                  Trigger when humidity less than
                </vs-th>
                <vs-th
                  sortKey="condition.max"
                  style="padding: 0px"
                  v-if="data[0].condition.max"
                >
                  Until<vs-icon icon="swap_vert" size="small" />
                </vs-th>
                <vs-th
                  sortKey="day"
                  style="padding: 0px"
                  v-if="!data[0].condition.min && !data[0].condition.max"
                >
                  Date
                </vs-th>
                <vs-th
                  sortKey="start"
                  style="padding: 0px"
                  v-if="!data[0].condition.min && !data[0].condition.max"
                >
                  Start Time
                </vs-th>
                <vs-th
                  sortKey="end"
                  style="padding: 0px"
                  v-if="!data[0].condition.min && !data[0].condition.max"
                >
                  End Time
                </vs-th>
                <vs-th sortKey="type" style="padding: 0px"> Type </vs-th>
                <vs-th
                  sortKey="mode"
                  style="padding: 0px"
                  v-if="!data[0].condition.min && !data[0].condition.max"
                >
                  Mode
                </vs-th>
                <vs-th sortKey="mode" style="padding: 0px"> Status </vs-th>
                <vs-th sortKey="modify" style="padding: 0px"> Modify </vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].date">
                    <vs-button
                      id="noWrap"
                      @click="updateTask(tr.id)"
                      icon="build"
                      type="flat"
                      :disabled="tr.status == true"
                    ></vs-button>
                    <vs-button
                      id="noWrap"
                      color="danger"
                      @click="deleteTask(tr.id, tr.sensor_id)"
                      icon="delete"
                      type="flat"
                      :disabled="tr.status == true"
                    ></vs-button>
                  </vs-td>
                  <vs-td :data="data[indextr].task">
                    {{ data[indextr].task }}
                  </vs-td>
                  <vs-td :data="data[indextr].sensor_id">
                    {{ data[indextr].sensor_id | lookupValveName(id) }}
                  </vs-td>
                  <vs-td
                    :data="data[indextr].condition.min"
                    v-if="data[0].condition.min"
                  >
                    {{ data[indextr].condition.min }}
                  </vs-td>
                  <vs-td
                    :data="data[indextr].condition.max"
                    v-if="data[0].condition.max"
                  >
                    {{ data[indextr].condition.max }}
                  </vs-td>
                  <vs-td
                    :data="data[indextr].day"
                    v-if="!data[0].condition.min && !data[0].condition.max"
                  >
                    <div v-for="(item, i) in data[indextr].day" :key="i">
                      {{ item }}
                    </div>
                  </vs-td>
                  <vs-td
                    :data="data[indextr].start"
                    v-if="!data[0].condition.min && !data[0].condition.max"
                  >
                    {{ data[indextr].start }}
                  </vs-td>
                  <vs-td
                    :data="data[indextr].end"
                    v-if="!data[0].condition.min && !data[0].condition.max"
                  >
                    {{ data[indextr].end }}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>
                  <vs-td
                    :data="data[indextr].mode"
                    v-show="!data[0].condition.min && !data[0].condition.max"
                  >
                    {{ data[indextr].mode }}
                  </vs-td>
                  <vs-td
                    :data="data[indextr].status"
                    v-show="data[indextr].status === true"
                  >
                    <vs-icon
                      align="center"
                      icon="fiber_manual_record"
                      color="primary"
                    >
                    </vs-icon>
                  </vs-td>
                  <vs-td
                    :data="data[indextr].status"
                    v-if="data[indextr].status === false"
                  >
                    <vs-icon
                      align="center"
                      icon="fiber_manual_record"
                      color="red"
                    >
                    </vs-icon>
                  </vs-td>
                  <vs-td :data="data[indextr].modify">
                    {{ data[indextr].modify }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card>
        </div>
      </vs-col>
      <vs-col vs-w="12" v-if="data.length === 0">
        <div>
          <vs-card style="border-radius: 20px">
            <vs-row id="center">
              <vs-list-header
                title="Tasks List"
                style="font-size: 18px"
                color="dark"
              ></vs-list-header>
              <vs-spacer />
              <vs-button
                radius
                v-b-modal.modal-xl
                color="#4caf50"
                type="filled"
                @click="openLogTask"
                icon="view_comfy"
                align="right"
              ></vs-button>
              <vs-button
                radius
                color="#4caf50"
                type="filled"
                @click="addTask"
                icon="playlist_add"
                align="right"
                class="ml-2"
              ></vs-button>
            </vs-row>
            <vs-table :data="data" max-items="8" pagination search>
              <template slot="thead">
                <vs-th> Action </vs-th>
                <vs-th sortKey="task" style="padding: 0px"> Task </vs-th>
                <vs-th style="padding: 0px"> Valve </vs-th>
                <vs-th style="padding: 0px"> Date </vs-th>
                <vs-th style="padding: 0px"> Start Time </vs-th>
                <vs-th style="padding: 0px"> End Time </vs-th>
                <vs-th style="padding: 0px"> Type </vs-th>
                <vs-th style="padding: 0px"> Status </vs-th>
                <vs-th style="padding: 0px"> Modify </vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].date">
                    <vs-button
                      id="noWrap"
                      @click="updateTask(tr.id)"
                      icon="build"
                      type="flat"
                      :disabled="tr.status == true"
                    ></vs-button>
                    <vs-button
                      id="noWrap"
                      color="danger"
                      @click="deleteTask(tr.id)"
                      icon="delete"
                      type="flat"
                      :disabled="tr.status == true"
                    ></vs-button>
                  </vs-td>
                  <vs-td :data="data[indextr].task">
                    {{ data[indextr].task }}
                  </vs-td>
                  <vs-td :data="data[indextr].valve">
                    {{ data[indextr].valve }}
                  </vs-td>
                  <vs-td :data="data[indextr].day">
                    {{ data[indextr].day }}
                  </vs-td>
                  <vs-td :data="data[indextr].start">
                    {{ data[indextr].start }}
                  </vs-td>
                  <vs-td :data="data[indextr].end">
                    {{ data[indextr].end }}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card>
        </div>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-w="12">
        <vs-card style="border-radius: 15px; padding-left: 5">
          <vs-row>
            <vs-list-header
              title="Soil Graph"
              style="font-size: 18px"
              color="dark"
            ></vs-list-header
            ><vs-spacer />
            <vs-select
              autocomplete
              @change="generateDataSoil()"
              v-model="select1"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.name"
                v-for="(item, index) in select"
              />
            </vs-select> </vs-row
          ><br />
          <SensorChart :chartData="this.chartData" :options="this.options" />
        </vs-card>
      </vs-col>
    </vs-row>
    <b-modal size="lg" ref="my-modal-AlertcreateTask" centered>
      <template #modal-title>
        <vs-row>
          <vs-icon icon="warning" color="danger" class="mr-2"> </vs-icon>
          <b class="text-danger">Create Task Error</b>
        </vs-row>
      </template>
      <div align="center">
        <vs-icon size="250px" icon="error_outline" color="danger"> </vs-icon
        ><br /><br />
        <b class="text-danger">this task don't during this time.</b>
      </div>

      <template #modal-footer>
        <vs-row>
          <vs-spacer />
          <vs-button
            id="btncancel"
            color="danger"
            style="border-radius: 20px; width: 10%"
            @click="closePopupErrorTask()"
          >
            Close
          </vs-button>
        </vs-row>
      </template>
    </b-modal>
    <b-modal size="lg" ref="my-modal-createTask">
      <template #modal-title>
        <div v-if="!id">Create Task</div>
        <div v-if="id">Update Task</div>
      </template>

      <vs-row>
        <vs-col type="flex" vs-justify="center" vs-w="12">
          <label for="feedback-taskName">Task Name</label>
          <b-input
            v-model="taskName"
            class="inputx"
            placeholder="Task Name"
            :state="validationTaskName"
            id="feedback-taskName"
            style="border-radius: 15px; width: 98%"
          />
          <b-form-invalid-feedback :state="validationTaskName">
            Please enter task name.
          </b-form-invalid-feedback>
          <b-form-valid-feedback :state="validationTaskName">
            Task name success.
          </b-form-valid-feedback>
        </vs-col>
        <vs-col class="mt-2" vs-w="12">
          <b-form-group v-slot="{ ariaDescribedby }">
            <!-- redio schedule -->
            <div v-if="id && selectedTask === 'schedule'">
              <b-form-radio
                v-model="selectedTask"
                :aria-describedby="ariaDescribedby"
                :state="validationTypeTask"
                name="some-radios"
                value="schedule"
                @change="
                  selectedTaskDay = 'day';
                  selectSoil = '';
                  waterUntil = '';
                  condition = '';
                  submitedValve = true;
                  submitedSoil = false;
                "
                >Schedule</b-form-radio
              >
              <label for="example-input" class="mt-1" style="padding-left: 23px"
                >Select valve controller</label
              >
              <vs-select
                v-if="selectedTask !== 'schedule'"
                disabled
                placeholder="Select"
                class="selectExample"
                v-model="selectSensorValve"
                style="width: 98%; padding-left: 20px"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.name"
                  v-for="(item, index) in dataSonsorValve"
                />
              </vs-select>
              <vs-select
                v-if="selectedTask === 'schedule'"
                disabled
                :state="validationValve"
                placeholder="Select"
                class="selectExample"
                v-model="selectSensorValve"
                style="width: 98%; padding-left: 20px"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.name"
                  v-for="(item, index) in dataSonsorValve"
                />
              </vs-select>
              <b-form-invalid-feedback :state="validationValve">
                Please select valve controller.
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validationValve">
                Valve controller success.
              </b-form-valid-feedback>
              <b-form-group
                style="padding-left: 20px"
                v-slot="{ ariaDescribedbySchedule }"
              >
                <b-form-radio
                  v-model="selectedTaskDay"
                  :aria-describedby="ariaDescribedbySchedule"
                  name="plain-inline"
                  value="day"
                  class="mt-2"
                  disabled
                  v-if="selectedTask !== 'schedule'"
                  >Day</b-form-radio
                >
                <b-form-radio
                  v-model="selectedTaskDay"
                  :aria-describedby="ariaDescribedbySchedule"
                  name="plain-inline"
                  value="day"
                  class="mt-2"
                  v-if="selectedTask === 'schedule'"
                  @change="
                    selectWeek = [];
                    startTimeWeek = '';
                    endTimeWeek = '';
                  "
                  >Day</b-form-radio
                >
                <vs-row class="mt-1">
                  <vs-col vs-w="4">
                    <label for="example-input">Select date</label>
                    <div class="con-select-example">
                      <vs-select
                        v-if="selectedTask !== 'schedule'"
                        disabled
                        placeholder="Select"
                        class="selectExample"
                        v-model="selectDay"
                        style="width: 100%"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.day"
                          :text="item.day"
                          v-for="(item, index) in dataWeek"
                        />
                      </vs-select>
                      <vs-select
                        v-if="
                          selectedTask === 'schedule' &&
                          selectedTaskDay === 'day'
                        "
                        placeholder="Select"
                        class="selectExample"
                        v-model="selectDay"
                        style="width: 100%"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.day"
                          :text="item.day"
                          v-for="(item, index) in dataWeek"
                        />
                      </vs-select>
                      <vs-select
                        v-if="
                          selectedTask === 'schedule' &&
                          selectedTaskDay === 'week'
                        "
                        disabled
                        placeholder="Select"
                        class="selectExample"
                        v-model="selectDay"
                        style="width: 100%"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.day"
                          :text="item.day"
                          v-for="(item, index) in dataWeek"
                        />
                      </vs-select>
                    </div>
                  </vs-col>
                  <vs-col vs-w="4">
                    <label for="example-input">Select start time</label>
                    <b-form-timepicker
                      v-model="startTimeDay"
                      v-if="selectedTask !== 'schedule'"
                      disabled
                      id="timepicker-placeholder"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="startTimeDay"
                      v-if="
                        selectedTask === 'schedule' && selectedTaskDay === 'day'
                      "
                      id="timepicker-placeholder"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="startTimeDay"
                      v-if="
                        selectedTask === 'schedule' &&
                        selectedTaskDay === 'week'
                      "
                      disabled
                      id="timepicker-placeholder"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                  </vs-col>
                  <vs-col vs-w="4">
                    <label for="timepicker-placeholder2">Select end time</label>
                    <b-form-timepicker
                      v-model="endTimeDay"
                      v-if="selectedTask !== 'schedule'"
                      disabled
                      id="timepicker-placeholder2"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="endTimeDay"
                      v-if="
                        selectedTask === 'schedule' && selectedTaskDay === 'day'
                      "
                      id="timepicker-placeholder2"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="endTimeDay"
                      v-if="
                        selectedTask === 'schedule' &&
                        selectedTaskDay === 'week'
                      "
                      disabled
                      id="timepicker-placeholder2"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                  </vs-col>
                </vs-row>
                <b-form-radio
                  v-model="selectedTaskDay"
                  :aria-describedby="ariaDescribedbySchedule"
                  name="plain-inline"
                  value="week"
                  v-if="selectedTask !== 'schedule'"
                  disabled
                  class="mt-2"
                  >Week</b-form-radio
                >
                <b-form-radio
                  v-model="selectedTaskDay"
                  :aria-describedby="ariaDescribedbySchedule"
                  name="plain-inline"
                  value="week"
                  v-if="selectedTask === 'schedule'"
                  @change="
                    selectDay = '';
                    startTimeDay = '';
                    endTimeDay = '';
                  "
                  class="mt-2"
                  >Week</b-form-radio
                >
                <vs-row class="mt-1">
                  <vs-col vs-w="6">
                    <label for="example-input">Select start time</label>
                    <b-form-timepicker
                      v-model="startTimeWeek"
                      v-if="selectedTask !== 'schedule'"
                      disabled
                      id="timepicker-placeholder"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="startTimeWeek"
                      v-if="
                        selectedTask === 'schedule' &&
                        selectedTaskDay === 'week'
                      "
                      id="timepicker-placeholder"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="startTimeWeek"
                      v-if="
                        selectedTask === 'schedule' && selectedTaskDay === 'day'
                      "
                      disabled
                      id="timepicker-placeholder"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                  </vs-col>
                  <vs-col vs-w="6">
                    <label for="timepicker-placeholder2">Select end time</label>
                    <b-form-timepicker
                      v-model="endTimeWeek"
                      v-if="selectedTask !== 'schedule'"
                      disabled
                      id="timepicker-placeholder2"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="endTimeWeek"
                      v-if="
                        selectedTask === 'schedule' &&
                        selectedTaskDay === 'week'
                      "
                      id="timepicker-placeholder2"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="endTimeWeek"
                      v-if="
                        selectedTask === 'schedule' && selectedTaskDay === 'day'
                      "
                      disabled
                      id="timepicker-placeholder2"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-w="12" class="mt-2">
                    <label for="example-input">Select date</label>
                    <div class="con-select-example">
                      <vs-select
                        v-if="selectedTask !== 'schedule'"
                        disabled
                        placeholder="Select"
                        class="selectExample"
                        multiple
                        v-model="selectWeek"
                        style="width: 100%"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.day"
                          :text="item.day"
                          v-for="(item, index) in dataWeek"
                        />
                      </vs-select>
                      <vs-select
                        v-if="
                          selectedTask === 'schedule' &&
                          selectedTaskDay === 'week'
                        "
                        placeholder="Select"
                        class="selectExample"
                        multiple
                        v-model="selectWeek"
                        style="width: 100%"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.day"
                          :text="item.day"
                          v-for="(item, index) in dataWeek"
                        />
                      </vs-select>
                      <vs-select
                        v-if="
                          selectedTask === 'schedule' &&
                          selectedTaskDay === 'day'
                        "
                        disabled
                        placeholder="Select"
                        class="selectExample"
                        multiple
                        v-model="selectWeek"
                        style="width: 100%"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.day"
                          :text="item.day"
                          v-for="(item, index) in dataWeek"
                        />
                      </vs-select>
                    </div>
                  </vs-col>
                </vs-row>
              </b-form-group>
            </div>
            <div v-if="!id">
              <b-form-radio
                v-model="selectedTask"
                :aria-describedby="ariaDescribedby"
                :state="validationTypeTask"
                name="some-radios"
                value="schedule"
                @change="
                  selectedTaskDay = 'day';
                  selectSoil = '';
                  waterUntil = '';
                  condition = '';
                  submitedValve = true;
                  submitedSoil = false;
                "
                >Schedule</b-form-radio
              >
              <label for="example-input" class="mt-1" style="padding-left: 23px"
                >Select valve controller</label
              >
              <vs-select
                v-if="selectedTask !== 'schedule'"
                disabled
                placeholder="Select"
                class="selectExample"
                v-model="selectSensorValve"
                style="width: 98%; padding-left: 20px"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.name"
                  v-for="(item, index) in dataSonsorValve"
                />
              </vs-select>
              <vs-select
                v-if="selectedTask === 'schedule'"
                :state="validationValve"
                placeholder="Select"
                class="selectExample"
                v-model="selectSensorValve"
                style="width: 98%; padding-left: 20px"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.name"
                  v-for="(item, index) in dataSonsorValve"
                />
              </vs-select>
              <b-form-invalid-feedback :state="validationValve">
                Please select valve controller.
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validationValve">
                Valve controller success.
              </b-form-valid-feedback>
              <b-form-group
                style="padding-left: 20px"
                v-slot="{ ariaDescribedbySchedule }"
              >
                <b-form-radio
                  v-model="selectedTaskDay"
                  :aria-describedby="ariaDescribedbySchedule"
                  name="plain-inline"
                  value="day"
                  class="mt-2"
                  disabled
                  v-if="selectedTask !== 'schedule'"
                  >Day</b-form-radio
                >
                <b-form-radio
                  v-model="selectedTaskDay"
                  :aria-describedby="ariaDescribedbySchedule"
                  name="plain-inline"
                  value="day"
                  class="mt-2"
                  v-if="selectedTask === 'schedule'"
                  @change="
                    selectWeek = [];
                    startTimeWeek = '';
                    endTimeWeek = '';
                  "
                  >Day</b-form-radio
                >
                <vs-row class="mt-1">
                  <vs-col vs-w="4">
                    <label for="example-input">Select date</label>
                    <div class="con-select-example">
                      <vs-select
                        v-if="selectedTask !== 'schedule'"
                        disabled
                        placeholder="Select"
                        class="selectExample"
                        v-model="selectDay"
                        style="width: 100%"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.day"
                          :text="item.day"
                          v-for="(item, index) in dataWeek"
                        />
                      </vs-select>
                      <vs-select
                        v-if="
                          selectedTask === 'schedule' &&
                          selectedTaskDay === 'day'
                        "
                        placeholder="Select"
                        class="selectExample"
                        v-model="selectDay"
                        style="width: 100%"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.day"
                          :text="item.day"
                          v-for="(item, index) in dataWeek"
                        />
                      </vs-select>
                      <vs-select
                        v-if="
                          selectedTask === 'schedule' &&
                          selectedTaskDay === 'week'
                        "
                        disabled
                        placeholder="Select"
                        class="selectExample"
                        v-model="selectDay"
                        style="width: 100%"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.day"
                          :text="item.day"
                          v-for="(item, index) in dataWeek"
                        />
                      </vs-select>
                    </div>
                  </vs-col>
                  <vs-col vs-w="4">
                    <label for="example-input">Select start time</label>
                    <b-form-timepicker
                      v-model="startTimeDay"
                      v-if="selectedTask !== 'schedule'"
                      disabled
                      id="timepicker-placeholder"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="startTimeDay"
                      v-if="
                        selectedTask === 'schedule' && selectedTaskDay === 'day'
                      "
                      id="timepicker-placeholder"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="startTimeDay"
                      v-if="
                        selectedTask === 'schedule' &&
                        selectedTaskDay === 'week'
                      "
                      disabled
                      id="timepicker-placeholder"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                  </vs-col>
                  <vs-col vs-w="4">
                    <label for="timepicker-placeholder2">Select end time</label>
                    <b-form-timepicker
                      v-model="endTimeDay"
                      v-if="selectedTask !== 'schedule'"
                      disabled
                      id="timepicker-placeholder2"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="endTimeDay"
                      v-if="
                        selectedTask === 'schedule' && selectedTaskDay === 'day'
                      "
                      id="timepicker-placeholder2"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="endTimeDay"
                      v-if="
                        selectedTask === 'schedule' &&
                        selectedTaskDay === 'week'
                      "
                      disabled
                      id="timepicker-placeholder2"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                  </vs-col>
                </vs-row>
                <b-form-radio
                  v-model="selectedTaskDay"
                  :aria-describedby="ariaDescribedbySchedule"
                  name="plain-inline"
                  value="week"
                  v-if="selectedTask !== 'schedule'"
                  disabled
                  class="mt-2"
                  >Week</b-form-radio
                >
                <b-form-radio
                  v-model="selectedTaskDay"
                  :aria-describedby="ariaDescribedbySchedule"
                  name="plain-inline"
                  value="week"
                  v-if="selectedTask === 'schedule'"
                  @change="
                    selectDay = '';
                    startTimeDay = '';
                    endTimeDay = '';
                  "
                  class="mt-2"
                  >Week</b-form-radio
                >
                <vs-row class="mt-1">
                  <vs-col vs-w="6">
                    <label for="example-input">Select start time</label>
                    <b-form-timepicker
                      v-model="startTimeWeek"
                      v-if="selectedTask !== 'schedule'"
                      disabled
                      id="timepicker-placeholder"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="startTimeWeek"
                      v-if="
                        selectedTask === 'schedule' &&
                        selectedTaskDay === 'week'
                      "
                      id="timepicker-placeholder"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="startTimeWeek"
                      v-if="
                        selectedTask === 'schedule' && selectedTaskDay === 'day'
                      "
                      disabled
                      id="timepicker-placeholder"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                  </vs-col>
                  <vs-col vs-w="6">
                    <label for="timepicker-placeholder2">Select end time</label>
                    <b-form-timepicker
                      v-model="endTimeWeek"
                      v-if="selectedTask !== 'schedule'"
                      disabled
                      id="timepicker-placeholder2"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="endTimeWeek"
                      v-if="
                        selectedTask === 'schedule' &&
                        selectedTaskDay === 'week'
                      "
                      id="timepicker-placeholder2"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                    <b-form-timepicker
                      v-model="endTimeWeek"
                      v-if="
                        selectedTask === 'schedule' && selectedTaskDay === 'day'
                      "
                      disabled
                      id="timepicker-placeholder2"
                      placeholder="HH:mm"
                      locale="en"
                    ></b-form-timepicker>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-w="12" class="mt-2">
                    <label for="example-input">Select date</label>
                    <div class="con-select-example">
                      <vs-select
                        v-if="selectedTask !== 'schedule'"
                        disabled
                        placeholder="Select"
                        class="selectExample"
                        multiple
                        v-model="selectWeek"
                        style="width: 100%"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.day"
                          :text="item.day"
                          v-for="(item, index) in dataWeek"
                        />
                      </vs-select>
                      <vs-select
                        v-if="
                          selectedTask === 'schedule' &&
                          selectedTaskDay === 'week'
                        "
                        placeholder="Select"
                        class="selectExample"
                        multiple
                        v-model="selectWeek"
                        style="width: 100%"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.day"
                          :text="item.day"
                          v-for="(item, index) in dataWeek"
                        />
                      </vs-select>
                      <vs-select
                        v-if="
                          selectedTask === 'schedule' &&
                          selectedTaskDay === 'day'
                        "
                        disabled
                        placeholder="Select"
                        class="selectExample"
                        multiple
                        v-model="selectWeek"
                        style="width: 100%"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.day"
                          :text="item.day"
                          v-for="(item, index) in dataWeek"
                        />
                      </vs-select>
                    </div>
                  </vs-col>
                </vs-row>
              </b-form-group>
            </div>

            <!-- radio soilMoistureBased -->
            <div v-if="id && selectedTask === 'soilMoistureBased'">
              <b-form-radio
                v-model="selectedTask"
                :aria-describedby="ariaDescribedby"
                :state="validationTypeTask"
                name="some-radios"
                value="soilMoistureBased"
                @change="
                  selectedTaskDay = '';
                  selectDay = '';
                  startTimeDay = '';
                  endTimeDay = '';
                  startTimeWeek = '';
                  endTimeWeek = '';
                  selectSensorValve = '';
                  submitedValve = false;
                  submitedSoil = true;
                "
                >Soil Moisture Based</b-form-radio
              >
              <vs-row>
                <vs-col
                  type="flex"
                  vs-justify="center"
                  vs-w="12"
                  style="padding-left: 22px"
                >
                  <label class="mt-2" for="example-input"
                    >Select soil sensor</label
                  >
                  <vs-select
                    v-if="selectedTask !== 'soilMoistureBased'"
                    autocomplete
                    disabled
                    placeholder="Select"
                    v-model="selectSoil"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.id"
                      :text="item.name"
                      v-for="(item, index) in dataSoil"
                    />
                  </vs-select>
                  <vs-select
                    v-if="selectedTask === 'soilMoistureBased'"
                    autocomplete
                    disabled
                    :state="validationSoil"
                    placeholder="Select"
                    v-model="selectSoil"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.id"
                      :text="item.name"
                      v-for="(item, index) in dataSoil"
                    />
                  </vs-select>
                  <b-form-invalid-feedback :state="validationSoil">
                    Please select soil sensor.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validationSoil">
                    Soil sensor success.
                  </b-form-valid-feedback>
                </vs-col>
              </vs-row>
              <vs-row class="mt-2">
                <vs-col vs-w="6" style="padding-left: 22px">
                  <label for="example-input"
                    >Trigger when humidity less than</label
                  >
                  <b-input
                    v-if="selectedTask !== 'soilMoistureBased'"
                    disabled
                    class="inputx"
                    placeholder="Placeholder"
                    v-model.number="condition"
                    style="width: 100%"
                  />
                  <b-input
                    v-if="selectedTask === 'soilMoistureBased'"
                    class="inputx"
                    placeholder="Placeholder"
                    v-model.number="condition"
                    style="width: 100%"
                  />
                </vs-col>
                <vs-col vs-w="6" style="padding-left: 22px">
                  <label for="example-input">Until</label>
                  <b-input
                    disabled
                    v-if="selectedTask !== 'soilMoistureBased'"
                    class="inputx"
                    placeholder="Placeholder"
                    v-model.number="waterUntil"
                    style="width: 100%"
                  />
                  <b-input
                    v-if="selectedTask === 'soilMoistureBased'"
                    class="inputx"
                    placeholder="Placeholder"
                    v-model.number="waterUntil"
                    style="width: 100%"
                  />
                </vs-col>
              </vs-row>
            </div>
            <div v-if="!id">
              <b-form-radio
                v-model="selectedTask"
                :aria-describedby="ariaDescribedby"
                :state="validationTypeTask"
                name="some-radios"
                value="soilMoistureBased"
                @change="
                  selectedTaskDay = '';
                  selectDay = '';
                  startTimeDay = '';
                  endTimeDay = '';
                  startTimeWeek = '';
                  endTimeWeek = '';
                  selectSensorValve = '';
                  submitedValve = false;
                  submitedSoil = true;
                "
                >Soil Moisture Based</b-form-radio
              >
              <vs-row>
                <vs-col
                  type="flex"
                  vs-justify="center"
                  vs-w="12"
                  style="padding-left: 22px"
                >
                  <label class="mt-2" for="example-input"
                    >Select soil sensor</label
                  >
                  <vs-select
                    v-if="selectedTask !== 'soilMoistureBased'"
                    autocomplete
                    disabled
                    placeholder="Select"
                    v-model="selectSoil"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.id"
                      :text="item.name"
                      v-for="(item, index) in dataSoil"
                    />
                  </vs-select>
                  <vs-select
                    v-if="selectedTask === 'soilMoistureBased'"
                    autocomplete
                    :state="validationSoil"
                    placeholder="Select"
                    v-model="selectSoil"
                    style="width: 100%"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.id"
                      :text="item.name"
                      v-for="(item, index) in dataSoil"
                    />
                  </vs-select>
                  <vs-alert
                    :active.sync="alertSoilSensorDuplicate"
                    closable
                    close-icon="close"
                    color="danger"
                  >
                    This sensor has been used.
                  </vs-alert>
                  <b-form-invalid-feedback :state="validationSoil">
                    Please select soil sensor.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validationSoil">
                    Soil sensor success.
                  </b-form-valid-feedback>
                </vs-col>
              </vs-row>
              <vs-row class="mt-2">
                <vs-col vs-w="6" style="padding-left: 22px">
                  <label for="example-input"
                    >Trigger when humidity less than</label
                  >
                  <b-input
                    v-if="selectedTask !== 'soilMoistureBased'"
                    disabled
                    class="inputx"
                    placeholder="Placeholder"
                    v-model.number="condition"
                    style="width: 100%"
                  />
                  <b-input
                    v-if="selectedTask === 'soilMoistureBased'"
                    class="inputx"
                    placeholder="Placeholder"
                    v-model.number="condition"
                    style="width: 100%"
                  />
                </vs-col>
                <vs-col vs-w="6" style="padding-left: 22px">
                  <label for="example-input">Until</label>
                  <b-input
                    disabled
                    v-if="selectedTask !== 'soilMoistureBased'"
                    class="inputx"
                    placeholder="Placeholder"
                    v-model.number="waterUntil"
                    style="width: 100%"
                  />
                  <b-input
                    v-if="selectedTask === 'soilMoistureBased'"
                    class="inputx"
                    placeholder="Placeholder"
                    v-model.number="waterUntil"
                    style="width: 100%"
                  />
                </vs-col>
              </vs-row>
            </div>

            <b-form-invalid-feedback :state="validationTypeTask"
              >Please select type task</b-form-invalid-feedback
            >
            <b-form-valid-feedback :state="validationTypeTask"
              >Select type task success</b-form-valid-feedback
            >
          </b-form-group>
        </vs-col>
      </vs-row>
      <div slot="modal-footer" class="w-100 text-right">
        <vs-button v-if="!id" color="primary" type="filled" class="mr-2"
          >Apply</vs-button
        >
        <vs-button v-if="id" color="primary" type="filled" class="mr-2"
          >Save</vs-button
        >
        <vs-button
          @click="closePopupCreateManhourGraph"
          color="grey"
          type="filled"
          >Cancel</vs-button
        >
      </div>
    </b-modal>
    <b-modal ref="modal-center" centered>
      <template #modal-title>
        <b class="text-danger">
          <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete
          Task</b
        >
      </template>
      <p class="my-4">Do you want to delete task?</p>
      <div slot="modal-footer" class="w-100 text-right">
        <vs-button
          color="grey"
          type="filled"
          @click="closePopupDeleteTask()"
          class="mr-2"
          >Cancel</vs-button
        >
        <vs-button color="danger" size="sm" type="filled">Delete</vs-button>
      </div>
    </b-modal>
    <b-modal ref="my-modal-logTask" size="xl">
      <template #modal-title> Log Task </template>
      <vs-tabs :color="colorx">
        <vs-tab @click="colorx = 'success'" label="History Log">
          <div class="con-tab-ejemplo">
            <vs-table :data="dataLogTask" max-items="8" pagination search>
              <template slot="thead">
                <vs-th sortKey="task" style="padding: 0px"> Task </vs-th>
                <vs-th sortKey="sensor_id" style="padding: 0px"> Sensor </vs-th>
                <vs-th sortKey="condition.min" style="padding: 0px">
                  Trigger when humidity less than
                </vs-th>
                <vs-th sortKey="condition.max" style="padding: 0px">
                  Until
                </vs-th>
                <vs-th sortKey="day" style="padding: 0px"> Date </vs-th>
                <vs-th sortKey="timestamp" style="padding: 0px">
                  Timestamp
                </vs-th>
                <vs-th sortKey="start" style="padding: 0px"> Start Time </vs-th>
                <vs-th sortKey="end" style="padding: 0px"> End Time </vs-th>
                <vs-th sortKey="type" style="padding: 0px"> Type </vs-th>
                <vs-th sortKey="mode" style="padding: 0px"> Mode </vs-th>
                <vs-th sortKey="modify" style="padding: 0px"> Modify </vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].task">
                    {{ data[indextr].task }}
                  </vs-td>
                  <vs-td :data="data[indextr].sensor_id">
                    {{ data[indextr].sensor_id | lookupValveName(id) }}
                  </vs-td>
                  <vs-td :data="data[indextr].condition.min">
                    {{ data[indextr].condition.min }}
                  </vs-td>
                  <vs-td :data="data[indextr].condition.max">
                    {{ data[indextr].condition.max }}
                  </vs-td>
                  <vs-td :data="data[indextr].day">
                    <div v-for="(item, i) in data[indextr].day" :key="i">
                      {{ item }}
                    </div>
                  </vs-td>
                  <vs-td :data="data[indextr].timestamp">
                    {{ data[indextr].created_at }}
                  </vs-td>
                  <vs-td :data="data[indextr].start">
                    {{ data[indextr].start }}
                  </vs-td>
                  <vs-td :data="data[indextr].end">
                    {{ data[indextr].end }}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>
                  <vs-td :data="data[indextr].mode">
                    {{ data[indextr].mode }}
                  </vs-td>
                  <vs-td :data="data[indextr].modify">
                    {{ data[indextr].modify }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
        <vs-tab @click="colorx = 'grey'" label="Removed Log">
          <div class="con-tab-ejemplo">
            <vs-table :data="dataLogTaskRemove" max-items="8" pagination search>
              <template slot="thead">
                <vs-th sortKey="task" style="padding: 0px"> Task </vs-th>
                <vs-th sortKey="sensor_id" style="padding: 0px"> Sensor </vs-th>
                <vs-th sortKey="condition.min" style="padding: 0px">
                  Trigger when humidity less than
                </vs-th>
                <vs-th sortKey="condition.max" style="padding: 0px">
                  Until
                </vs-th>
                <vs-th sortKey="day" style="padding: 0px"> Date </vs-th>
                <vs-th sortKey="timestamp" style="padding: 0px">
                  Timestamp
                </vs-th>
                <vs-th sortKey="start" style="padding: 0px"> Start Time </vs-th>
                <vs-th sortKey="end" style="padding: 0px"> End Time </vs-th>
                <vs-th sortKey="type" style="padding: 0px"> Type </vs-th>
                <vs-th sortKey="mode" style="padding: 0px"> Mode </vs-th>
                <vs-th sortKey="modify" style="padding: 0px"> Modify </vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].task">
                    {{ data[indextr].task }}
                  </vs-td>
                  <vs-td :data="data[indextr].sensor_id">
                    {{ data[indextr].sensor_id | lookupValveName(id) }}
                  </vs-td>
                  <vs-td :data="data[indextr].condition.min">
                    {{ data[indextr].condition.min }}
                  </vs-td>
                  <vs-td :data="data[indextr].condition.max">
                    {{ data[indextr].condition.max }}
                  </vs-td>
                  <vs-td :data="data[indextr].day">
                    <div v-for="(item, i) in data[indextr].day" :key="i">
                      {{ item }}
                    </div>
                  </vs-td>
                  <vs-td :data="data[indextr].timestamp">
                    {{ data[indextr].created_at }}
                  </vs-td>
                  <vs-td :data="data[indextr].start">
                    {{ data[indextr].start }}
                  </vs-td>
                  <vs-td :data="data[indextr].end">
                    {{ data[indextr].end }}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].type }}
                  </vs-td>
                  <vs-td :data="data[indextr].mode">
                    {{ data[indextr].mode }}
                  </vs-td>
                  <vs-td :data="data[indextr].modify">
                    {{ data[indextr].modify }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
      </vs-tabs>

      <div slot="modal-footer" class="w-100 text-right">
        <vs-button @click="closePopupLogTask" color="grey" type="filled"
          >Cancel</vs-button
        >
      </div>
    </b-modal>
  </div>
</template>
<script>
import itemmap from "./compo/itemmap.vue";
import SensorChart from "./compo/SensorChart";
import TempChart from "./compo/TempChart";
import HumidChart from "./compo/HumidChart";
import moment from "moment";
export default {
  components: {
    SensorChart,
    TempChart,
    HumidChart,
    itemmap,
  },
  data() {
    return {
      breakInterval: false,
      dataLogTask: [],
      dataLogTaskRemove: [],
      colorx: "success",
      alertSoilSensorDuplicate: false,
      submited: false,
      submitedValve: false,
      submitedSoil: false,
      sennsor_id: "",
      id: "",
      statusTank: false,
      statusValve1: false,
      statusValve2: false,
      statusValve3: false,
      statusValve4: false,
      statusValve5: false,
      statusValve6: false,
      waterUntil: "",
      condition: "",
      select1Normal: "",
      selectWeek: [],
      selectWeekDay: "",
      selectDay: "",
      startTimeDay: "",
      endTimeDay: "",
      startTimeWeek: "",
      endTimeWeek: "",
      selectedTaskDay: "",
      selectedTask: "",
      taskName: "",
      selectSensorValve: "",
      selectSoil: "",
      dataSonsorValve: [],
      dataWeek: [
        { day: "Monday", value: 1 },
        { day: "Tuesday", value: 2 },
        { day: "Wednesday", value: 3 },
        { day: "Thursday", value: 4 },
        { day: "Friday", value: 5 },
        { day: "Saturday", value: 6 },
        { day: "Sunday", value: 7 },
      ],
      dataSoil: [],
      chooseWeek: "",
      data: [
        {
          id: "89",
          type: "soilMoistureBased",
          task: "soil base",
          condition: {
            min: 20,
            max: 40,
          },
          mode: null,
          day: null,
          start: null,
          end: null,
          status: false,
          active: true,
          modify: "sbr",
          work_end: "isactive",
          sensor_id: 507,
        },
      ],
      chartData: null,
      options: null,
      chartData1: null,
      options1: null,
      chartData2: null,
      options2: null,
      tempArray: [],
      humidArray: [],
      dateArray: [],
      moistureArray1: [],
      moistureArray2: [],
      moistureArray3: [],
      soilTempArray1: [],
      soilTempArray2: [],
      soilTempArray3: [],
      ecArray1: [],
      ecArray2: [],
      ecArray3: [],
      chartHumid: false,
      chartTemp: false,
      chartSoil: false,
      tempCurrent: 0,
      humidCurrent: 0,
      soilMoistureCurrent1: 0,
      soilMoistureCurrent2: 0,
      soilMoistureCurrent3: 0,
      soilTempCurrent1: 0,
      soilTempCurrent2: 0,
      soilTempCurrent3: 0,
      soilEcCurrent1: 0,
      soilEcCurrent2: 0,
      soilEcCurrent3: 0,
      dateArrayTemp: [],
      dateSum: 0,
      dateAVG: 0,
      dateNewArray: [],
      dateArray1: [],
      dateArray2: [],
      dateArray3: [],
      dateSumCurrent: 0,
      dateAVGCurrent: 0,
      dateCurrent1: 0,
      dateCurrent2: 0,
      dateCurrent3: 0,
      select: [
        { name: "Soil Moisture", value: "moisture" },
        { name: "Soil Temperature", value: "temp" },
        { name: "Soil EC", value: "ec" },
      ],
      select1: null,
      chart: false,
      resultfindById: {},
      interval1: null,
      interval2: null,
      interval3: null,
    };
  },
  filters: {
    lookupValveName(id) {
      switch (id) {
        case 510:
          return "valve1";
          break;
        case 511:
          return "valve2";
          break;
        case 512:
          return "valve3";
          break;
        case 513:
          return "valve4";
          break;
        case 514:
          return "valve5";
          break;
        case 515:
          return "valve6";
          break;
        case 507:
          return "soil1";
          break;
        case 508:
          return "soil2";
          break;
        case 509:
          return "soil3";
      }
    },
  },
  computed: {
    validationTaskName() {
      if (this.submited) {
        return this.taskName.length > 0;
      }
    },
    validationTypeTask() {
      if (this.submited) {
        return this.selectedTask.length > 0;
      }
    },
    validationValve() {
      if (this.submited && this.submitedValve) {
        if (!this.selectSensorValve) {
          return this.selectSensorValve > 0;
        }
      }
    },
    validationSoil() {
      if (this.submited && this.submitedSoil) {
        if (!this.selectSoil) {
          return this.selectSoil > 0;
        }
      }
    },
  },
  created() {
    this.getMapSensor();
    this.interval1 = setInterval(() => {
      if (this.breakInterval === false) {
        this.getMapSensor();
      }
    }, 60000);
    this.getTaskAll();
    this.getSensorValveAll();
    this.getSelect();
    this.generateDataSoil();
    this.generateDataTemp();
  },
  beforeDestroy() {
    clearInterval(this.interval1);
    clearInterval(this.interval2);
    clearInterval(this.interval3);
  },
  methods: {
    getMapSensor() {
      const allsensor = [
        {
          id: 506,
          name: "level",
          type: "proximity",
          status: "off",
        },
        {
          id: 507,
          name: "soil1",
          type: "soil",
          status: "off",
        },
        {
          id: 508,
          name: "soil2",
          type: "soil",
          status: "off",
        },
        {
          id: 509,
          name: "soil3",
          type: "soil",
          status: "off",
        },
        {
          id: 510,
          name: "valve1",
          type: "valve",
          status: "pending",
        },
        {
          id: 511,
          name: "valve2",
          type: "valve",
          status: "off",
        },
        {
          id: 512,
          name: "valve3",
          type: "valve",
          status: "off",
        },
        {
          id: 513,
          name: "valve4",
          type: "valve",
          status: "off",
        },
        {
          id: 514,
          name: "valve5",
          type: "valve",
          status: "off",
        },
        {
          id: 515,
          name: "valve6",
          type: "valve",
          status: "off",
        },
        {
          id: 516,
          name: "temp",
          type: "temp",
          status: "off",
        },
        {
          id: 517,
          name: "pump",
          type: "pump",
          status: "off",
        },
      ];
      console.log(allsensor);
      allsensor.forEach((sensor) => {
        switch (sensor.id) {
          case 510:
            if (sensor.status === "on") {
              this.statusValve1 = true;
              break;
            } else if (sensor.status === "off") {
              this.statusValve1 = false;
              break;
            } else {
              this.statusValve1 = "pending";
              break;
            }
          case 511:
            if (sensor.status === "on") {
              this.statusValve2 = true;
              break;
            } else if (sensor.status === "off") {
              this.statusValve2 = false;
              break;
            } else {
              this.statusValve2 = "pending";
              break;
            }
          case 512:
            if (sensor.status === "on") {
              this.statusValve3 = true;
              break;
            } else if (sensor.status === "off") {
              this.statusValve3 = false;
              break;
            } else {
              this.statusValve3 = "pending";
              break;
            }
          case 513:
            if (sensor.status === "on") {
              this.statusValve4 = true;
              break;
            } else if (sensor.status === "off") {
              this.statusValve4 = false;
              break;
            } else {
              this.statusValve4 = "pending";
              break;
            }
          case 514:
            if (sensor.status === "on") {
              this.statusValve5 = true;
              break;
            } else if (sensor.status === "off") {
              this.statusValve5 = false;
              break;
            } else {
              this.statusValve5 = "pending";
              break;
            }
          case 515:
            if (sensor.status === "on") {
              this.statusValve6 = true;
              break;
            } else if (sensor.status === "off") {
              this.statusValve6 = false;
              break;
            } else {
              this.statusValve6 = "pending";
              break;
            }
          // case 517:
          //   return (this.statusTank = sensor.status);
        }
      });

      this.$API.get("sribun/getProximity").then((result) => {
        // console.log(result.data.result.data[0].currentdata[0].onoff_status,typeof(result.data.result.data[0].currentdata[0].onoff_status))
        this.statusTank =
          result.data.result.data[0].currentdata[0].onoff_status == 1
            ? "on"
            : "off";
      });
      // if ((this.breakInterval = false)) {
      //   setInterval(() => {
      //     this.getMapSensor();
      //   }, 10000);
      // }
    },
    getTaskAll() {
      this.$API.get("sribun/task/findAll").then((result) => {
        this.data = result.data.result;
      });
      setTimeout(() => {
        this.getTaskAll();
      }, 6000);
    },
    getTaskById() {
      const id = this.id;
      this.$API.get("sribun/task/find/" + id).then((result) => {
        const data = result.data.result[0];
        if (data.type === "schedule") {
          if (data.mode === "day") {
            this.taskName = data.task;
            this.selectSensorValve = data.sensor_id;
            this.selectedTask = data.type;
            this.selectedTaskDay = data.mode;
            this.selectDay = data.day[0];
            this.startTimeDay = data.start;
            this.endTimeDay = data.end;
          } else {
            this.taskName = data.task;
            this.selectSensorValve = data.sensor_id;
            this.selectedTask = data.type;
            this.selectedTaskDay = data.mode;
            this.selectWeek = data.day;
            this.startTimeWeek = data.start;
            this.endTimeWeek = data.end;
          }
        } else {
          this.taskName = data.task;
          this.selectSensorValve = data.sensor_id;
          this.selectSoil = data.sensor_id;
          this.selectedTask = data.type;
          this.condition = data.condition.min;
          this.waterUntil = data.condition.max;
        }
      });
    },
    addTask() {
      (this.submited = false),
        (this.submitedValve = false),
        (this.submitedSoil = false),
        (this.id = "");
      this.taskName = "";
      this.selectSensorValve = "";
      this.selectedTask = "";
      this.selectedTaskDay = "";
      this.selectDay = "";
      this.startTimeDay = "";
      this.endTimeDay = "";
      this.startTimeWeek = "";
      this.endTimeWeek = "";
      this.selectWeek = [];
      this.selectSoil = "";
      this.condition = "";
      this.waterUntil = "";
      this.$refs["my-modal-createTask"].show();
    },
    async applyTask() {
      this.submited = true;
      if (this.taskName && this.selectedTask) {
        if (this.selectedTask === "schedule" && this.selectSensorValve) {
          if (this.selectedTaskDay === "day") {
            this.openLoading();
            const data = {
              task: this.taskName,
              mode: this.selectedTaskDay,
              day: [this.selectDay],
              start: this.startTimeDay,
              end: this.endTimeDay,
              type: this.selectedTask,
              sensor_id: Number(this.selectSensorValve),
              condition: {
                min: null,
                max: null,
              },
            };
            this.$API
              .post("sribun/sensor/task/create", data)
              .then((res) => {
                if (res.status === 200) {
                  this.$refs["my-modal-createTask"].hide();
                  this.getTaskAll();
                  return res;
                } else if (res.response.status === 400) {
                  this.$refs["my-modal-createTask"].hide();
                  this.$refs["my-modal-AlertcreateTask"].show();
                }
                return res;
              })
              .catch((err) => {
                return err.response;
              });
          } else {
            this.openLoading();
            const data = {
              task: this.taskName,
              mode: this.selectedTaskDay,
              day: this.selectWeek,
              start: this.startTimeWeek,
              end: this.endTimeWeek,
              type: this.selectedTask,
              sensor_id: Number(this.selectSensorValve),
              condition: {
                min: null,
                max: null,
              },
            };
            this.$API
              .post("sribun/sensor/task/create", data)
              .then((res) => {
                if (res.status === 200) {
                  this.$refs["my-modal-createTask"].hide();
                  this.getTaskAll();
                  return res;
                }
              })
              .catch((err) => {
                return err.response;
              });
          }
        }
        if (this.selectedTask === "soilMoistureBased" && this.selectSoil) {
          this.openLoading();
          const data = {
            task: this.taskName,
            type: this.selectedTask,
            sensor_id: Number(this.selectSoil),
            condition: {
              min: this.condition,
              max: this.waterUntil,
            },
          };
          this.$API
            .post("sribun/sensor/task/create", data)
            .then((res) => {
              if (res.status === 200) {
                this.$refs["my-modal-createTask"].hide();
                this.getTaskAll();
                return res;
              } else {
                this.alertSoilSensorDuplicate = true;
              }
            })
            .catch((err) => {
              return err.response;
            });
        }
      }
    },
    updateApplyTask() {
      this.submited = true;
      if (this.taskName && this.selectedTask) {
        if (this.selectedTask === "schedule" && this.selectSensorValve) {
          if (this.selectedTaskDay === "day") {
            this.openLoading();
            const data = {
              id: this.id,
              task: this.taskName,
              mode: this.selectedTaskDay,
              day: [this.selectDay],
              start: this.startTimeDay,
              end: this.endTimeDay,
              type: this.selectedTask,
              sensor_id: Number(this.selectSensorValve),
              condition: {
                min: null,
                max: null,
              },
            };
            this.$API
              .put("sribun/task/update", data)
              .then((res) => {
                if (res.status === 200) {
                  this.$refs["my-modal-createTask"].hide();
                  this.getTaskAll();
                  return res;
                }
              })
              .catch((err) => {
                // console.log(err.response.status, "checklog");
              });
          } else {
            this.openLoading();
            const data = {
              id: this.id,
              task: this.taskName,
              mode: this.selectedTaskDay,
              day: this.selectWeek,
              start: this.startTimeWeek,
              end: this.endTimeWeek,
              type: this.selectedTask,
              sensor_id: Number(this.selectSensorValve),
              condition: {
                min: null,
                max: null,
              },
            };
            this.$API
              .put("sribun/task/update", data)
              .then((res) => {
                if (res.status === 200) {
                  this.$refs["my-modal-createTask"].hide();
                  this.getTaskAll();
                  return res;
                }
              })
              .catch((err) => {
                return err.response;
              });
          }
        }
        if (this.selectedTask === "soilMoistureBased" && this.selectSoil) {
          this.openLoading();
          const data = {
            id: this.id,
            task: this.taskName,
            type: this.selectedTask,
            sensor_id: Number(this.selectSoil),
            condition: {
              min: this.condition,
              max: this.waterUntil,
            },
          };
          this.$API
            .put("sribun/task/update", data)
            .then((res) => {
              if (res.status === 200) {
                this.$refs["my-modal-createTask"].hide();
                this.getTaskAll();
                return res;
              }
            })
            .catch((err) => {
              return err.response;
            });
        }
      }
    },
    delTask() {
      this.openLoading();
      const data = {
        id: this.id,
        sensor_id: this.sensorId,
        active: false,
        work_end: "remove",
      };
      this.$API.put("sribun/task/update", data).then((res) => {
        if (res.status === 200) {
          this.$refs["modal-center"].hide();
          this.getTaskAll();
          return res;
        }
      });
    },
    openLogTask() {
      this.dataLogTask = [];
      this.dataLogTaskRemove = [];
      this.colorx = "success";
      this.getLogTask();
      this.$refs["my-modal-logTask"].show();
    },
    closePopupLogTask() {
      this.$refs["my-modal-logTask"].hide();
    },
    closePopupCreateManhourGraph() {
      this.$refs["my-modal-createTask"].hide();
    },
    getSelect() {
      this.select1 = this.select[0].value;
    },
    deleteTask(id, sensorId) {
      this.$refs["modal-center"].show();
      this.id = id;
      this.sensorId = sensorId;
    },
    closePopupDeleteTask() {
      this.$refs["modal-center"].hide();
    },
    closePopupErrorTask() {
      this.$refs["my-modal-AlertcreateTask"].hide();
    },
    openPopupErrorTask() {
      this.$refs["my-modal-AlertcreateTask"].show();
    },
    generateDataTemp() {
      this.tempArray = [];
      this.humidArray = [];
      this.chartTemp = false;
      this.chartHumid = false;
      this.$API.get("sribun/temp").then((result) => {
        this.tempCurrent = result.data.result.currentdata.temperature;
        this.humidCurrent = result.data.result.currentdata.humidity;
        for (var i = 0; i <= result.data.result.data.length; i++) {
          let obj = result.data.result.data[i];
          if (obj != undefined) {
            this.tempArray.push(obj.data.temperature);
            this.humidArray.push(obj.data.humidity);
            this.dateArrayTemp.push(obj.timestamps);
          }
        }
      });
      this.chartData1 = {
        labels: this.dateArrayTemp,
        datasets: [
          {
            type: "line",
            data: this.tempArray,
            borderColor: "rgba(240, 232, 6,.3)",
            fill: false,
            borderWidth: 3,
            pointRadius: 0,
          },
        ],
      };
      this.options1 = {
        responsive: true,
        maintainAspectRatio: false,

        legend: {
          position: "bottom",
          display: false,
        },
        scales: {
          yAxes: [
            {
              id: "A",
              beginAtZero: true,
              gridLines: {
                display: false,
              },
              ticks: {
                min: 0,
                max: 100,
                beginAtZero: true,
                display: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                display: false,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
      };
      this.chartData2 = {
        labels: this.dateArrayTemp,
        datasets: [
          {
            type: "line",
            data: this.humidArray,
            borderColor: "rgba(6, 215, 240,.3)",
            fill: false,
            borderWidth: 3,
            pointRadius: 0,
          },
        ],
      };
      this.options2 = {
        responsive: true,
        maintainAspectRatio: false,

        legend: {
          position: "bottom",
          display: false,
        },
        scales: {
          yAxes: [
            {
              id: "A",
              beginAtZero: true,
              gridLines: {
                display: false,
              },
              ticks: {
                min: 0,
                max: 100,
                beginAtZero: true,
                display: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                display: false,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
      };
      setTimeout(() => {
        this.chartTemp = true;
        this.chartHumid = true;
      }, 1000);
      this.interval2 = setInterval(() => {
        this.tempArray.splice(0, 1);
        this.humidArray.splice(0, 1);
        this.dateArrayTemp.splice(0, 1);
        this.$API.get("sribun/temp").then((result) => {
          this.tempCurrent = result.data.result.currentdata.temperature;
          this.humidCurrent = result.data.result.currentdata.humidity;
          this.tempArray.push(this.tempCurrent);
          this.humidArray.push(this.humidCurrent);
          this.dateArrayTemp.push(result.data.result.timestamps);
        });
      }, 720000);
    },
    generateDataSoil() {
      this.moistureArray1 = [];
      this.moistureArray2 = [];
      this.moistureArray3 = [];
      this.soilTempArray1 = [];
      this.soilTempArray2 = [];
      this.soilTempArray3 = [];
      this.ecArray1 = [];
      this.ecArray2 = [];
      this.ecArray3 = [];
      this.dateArray1 = [];
      this.dateArray2 = [];
      this.dateArray3 = [];
      this.dateNewArray = [];
      (this.dateSum = 0), (this.dateAVG = 0);
      this.chartSoil = false;
      this.$API.get("sribun/soil").then((result) => {
        this.soilMoistureCurrent1 =
          result.data.result.soil1_currentdata.humidity;
        this.soilMoistureCurrent2 =
          result.data.result.soil2_currentdata.humidity;
        this.soilMoistureCurrent3 =
          result.data.result.soil3_currentdata.humidity;
        this.soilTempCurrent1 =
          result.data.result.soil1_currentdata.temperature;
        this.soilTempCurrent2 =
          result.data.result.soil2_currentdata.temperature;
        this.soilTempCurrent3 =
          result.data.result.soil3_currentdata.temperature;
        this.soilEcCurrent1 = result.data.result.soil1_currentdata.ec;
        this.soilEcCurrent2 = result.data.result.soil2_currentdata.ec;
        this.soilEcCurrent3 = result.data.result.soil3_currentdata.ec;
        for (var i = 0; i <= result.data.result.soil1.length; i++) {
          let obj1 = result.data.result.soil1[i];
          if (obj1 != undefined) {
            if (obj1.data != null) {
              this.moistureArray1.push(obj1.data.humidity);
              this.soilTempArray1.push(obj1.data.temperature);
              this.ecArray1.push(obj1.data.ec);
            } else {
              this.moistureArray1.push(0);
              this.soilTempArray1.push(0);
              this.ecArray1.push(0);
            }
            this.dateArray1.push(obj1.timestamps);
          }
        }

        for (var i = 0; i <= result.data.result.soil2.length; i++) {
          let obj2 = result.data.result.soil2[i];
          if (obj2 != undefined) {
            if (obj2.data != null) {
              this.moistureArray2.push(obj2.data.humidity);
              this.soilTempArray2.push(obj2.data.temperature);
              this.ecArray2.push(obj2.data.ec);
            } else {
              this.moistureArray2.push(0);
              this.soilTempArray2.push(0);
              this.ecArray2.push(0);
            }
            this.dateArray2.push(obj2.timestamps);
          }
        }

        for (var i = 0; i <= result.data.result.soil3.length; i++) {
          let obj3 = result.data.result.soil3[i];
          if (obj3 != undefined) {
            if (obj3.data != null) {
              this.moistureArray3.push(obj3.data.humidity);
              this.soilTempArray3.push(obj3.data.temperature);
              this.ecArray3.push(obj3.data.ec);
            } else {
              this.moistureArray3.push(0);
              this.soilTempArray3.push(0);
              this.ecArray3.push(0);
            }
            this.dateArray3.push(obj3.timestamps);
          }
        }

        for (var i = 0; i < this.dateArray2.length; i++) {
          this.dateSum =
            new Date(this.dateArray1[i]).getTime() +
            new Date(this.dateArray2[i]).getTime() +
            new Date(this.dateArray3[i]).getTime();
          this.dateAVG = this.dateSum / 3;
          this.dateNewArray.push(moment(this.dateAVG).format("LTS"));
        }
      });
      this.chartData = {
        labels: [
          "11 June 2022",
          "12 June 2022",
          "13 June 2022",
          "14 June 2022",
          "15 June 2022",
        ],
        datasets: [
          {
            label: "Soil Moisture1",
            type: "line",
            data: [58, 52, 52, 56, 51],
            borderColor: "rgba(20, 153, 242,.3)",
            fill: false,
            borderWidth: 3,
          },
          {
            label: "Soil Moisture2",
            type: "line",
            data: [29, 37, 33, 36, 31],
            borderColor: "rgba(247, 15, 15,.2)",
            fill: false,
            borderWidth: 3,
          },
          {
            label: "Soil Moisture3",
            type: "line",
            data: [48, 42, 42, 46, 41],
            borderColor: "rgba(24, 236, 133,.2)",
            fill: false,
            borderWidth: 3,
          },
        ],
      };
      this.options = {
        responsive: true,
        maintainAspectRatio: false,

        legend: {
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              beginAtZero: true,

              position: "left",
              scaleLabel: {
                display: true,
                labelString: "Soil Moisture (%)",
              },
              ticks: {
                min: 0,
                max: 100,
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: "Time",
              },
            },
          ],
        },
      };
      setTimeout(() => {
        this.chartSoil = true;
      }, 3000);
      this.interval1 = setInterval(() => {
        this.dateSumCurrent = 0;
        this.dateAVGCurrent = 0;
        this.moistureArray1.splice(0, 1);
        this.moistureArray2.splice(0, 1);
        this.moistureArray3.splice(0, 1);
        this.soilTempArray1.splice(0, 1);
        this.soilTempArray2.splice(0, 1);
        this.soilTempArray3.splice(0, 1);
        this.ecArray1.splice(0, 1);
        this.ecArray2.splice(0, 1);
        this.ecArray3.splice(0, 1);
        this.dateNewArray.splice(0, 1);
        this.$API.get("sribun/soil").then((result) => {
          this.soilMoistureCurrent1 =
            result.data.result.soil1_currentdata.humidity;
          this.soilTempCurrent1 =
            result.data.result.soil1_currentdata.temperature;
          this.soilEcCurrent1 = result.data.result.soil1_currentdata.ec;
          this.soilMoistureCurrent2 =
            result.data.result.soil2_currentdata.humidity;
          this.soilTempCurrent2 =
            result.data.result.soil2_currentdata.temperature;
          this.soilEcCurrent2 = result.data.result.soil2_currentdata.ec;
          this.soilMoistureCurrent3 =
            result.data.result.soil3_currentdata.humidity;
          this.soilTempCurrent3 =
            result.data.result.soil3_currentdata.temperature;
          this.soilEcCurrent3 = result.data.result.soil3_currentdata.ec;
          this.dateCurrent1 = result.data.result.soil1_timestamps;
          this.dateCurrent2 = result.data.result.soil2_timestamps;
          this.dateCurrent3 = result.data.result.soil3_timestamps;
          this.dateSumCurrent =
            new Date(this.dateCurrent1).getTime() +
            new Date(this.dateCurrent2).getTime() +
            new Date(this.dateCurrent3).getTime();
          this.dateAVGCurrent = this.dateSumCurrent / 3;
          this.moistureArray1.push(this.soilMoistureCurrent1);
          this.moistureArray2.push(this.soilMoistureCurrent2);
          this.moistureArray3.push(this.soilMoistureCurrent3);
          this.soilTempArray1.push(this.soilTempCurrent1);
          this.soilTempArray2.push(this.soilTempCurrent2);
          this.soilTempArray3.push(this.soilTempCurrent3);
          this.ecArray1.push(this.soilEcCurrent1);
          this.ecArray2.push(this.soilEcCurrent2);
          this.ecArray3.push(this.soilEcCurrent3);
          this.dateNewArray.push(moment(this.dateAVGCurrent).format("LTS"));
        });
      }, 720000);
    },

    updateTask(id) {
      this.id = id;
      this.taskName = "";
      this.selectSensorValve = "";
      this.selectedTask = "";
      this.selectedTaskDay = "";
      this.selectDay = "";
      this.startTimeDay = "";
      this.endTimeDay = "";
      this.startTimeWeek = "";
      this.endTimeWeek = "";
      this.selectWeek = [];
      this.selectSoil = "";
      this.condition = "";
      this.waterUntil = "";
      this.$refs["my-modal-createTask"].show();
      this.getTaskById();
    },
    getSensorValveAll() {
      this.$API.get("sribun/sensor").then((result) => {
        result.data.result.forEach((element) => {
          if (element.type === "valve") {
            this.dataSonsorValve.push(element);
          }
          if (element.type === "soil") {
            this.dataSoil.push(element);
          }
        });
      });
    },
    getLogTask() {
      this.$API.get("sribun/task-log/findAll").then((result) => {
        result.data.forEach((element) => {
          if (element.work_end === "fail") {
            this.dataLogTask.push(element);
          }
          if (element.work_end === "remove") {
            this.dataLogTaskRemove.push(element);
          }
        });
      });
    },
    openLoading() {
      this.activeLoading = true;
      this.$vs.loading({
        type: "radius",
      });
      setTimeout(() => {
        this.activeLoading = false;
        this.$vs.loading.close();
      }, 500);
    },
    onOffValve(sensor) {
      console.log(sensor, "log");
    },
    // onOffValve(sensor) {
    //   // console.log(sensor, "log");
    //   switch (sensor) {
    //     case "statusValve1":
    //       let data = {
    //         sensor_id: 510,
    //         status_manual: this.statusValve1,
    //       };
    //       // console.log(data, "data");
    //       this.$API
    //         .put("sribun/statusmanual", data)
    //         .then((res) => {
    //           if (res.status === 200) {
    //             this.statusValve1 = "pending";
    //             // console.log(data.sensor_id, "pp");
    //             this.breakInterval = true;
    //             setTimeout(() => {
    //               this.getSensorById(data.sensor_id);
    //               this.breakInterval = false;
    //             }, 300000);
    //             // this.getSensorById(data.sensor_id);
    //           }
    //         })
    //         .catch((err) => {
    //           return err.response;
    //         });
    //       break;
    //     case "statusValve2":
    //       let data2 = {
    //         sensor_id: 511,
    //         status_manual: this.statusValve2,
    //       };
    //       // console.log(data2, "data");
    //       this.$API
    //         .put("sribun/statusmanual", data2)
    //         .then((res) => {
    //           if (res.status === 200) {
    //             this.statusValve2 = "pending";
    //             this.breakInterval = true;
    //             setTimeout(() => {
    //               this.getSensorById(data2.sensor_id);
    //               this.breakInterval = false;
    //             }, 300000);
    //             // this.getSensorById(data.sensor_id);
    //           }
    //         })
    //         .catch((err) => {
    //           return err.response;
    //         });
    //       break;
    //     case "statusValve3":
    //       let data3 = {
    //         sensor_id: 512,
    //         status_manual: this.statusValve3,
    //       };
    //       // console.log(data3, "data");
    //       this.$API
    //         .put("sribun/statusmanual", data3)
    //         .then((res) => {
    //           if (res.status === 200) {
    //             this.statusValve3 = "pending";
    //             this.breakInterval = true;
    //             setTimeout(() => {
    //               this.getSensorById(data3.sensor_id);
    //               this.breakInterval = false;
    //             }, 300000);
    //             // this.getSensorById(data.sensor_id);
    //           }
    //         })
    //         .catch((err) => {
    //           return err.response;
    //         });
    //       break;
    //     case "statusValve4":
    //       let data4 = {
    //         sensor_id: 513,
    //         status_manual: this.statusValve4,
    //       };
    //       // console.log(data4, "data");
    //       this.$API
    //         .put("sribun/statusmanual", data4)
    //         .then((res) => {
    //           if (res.status === 200) {
    //             this.statusValve4 = "pending";
    //             this.breakInterval = true;
    //             setTimeout(() => {
    //               this.getSensorById(data4.sensor_id);
    //               this.breakInterval = false;
    //             }, 300000);
    //             // this.getSensorById(data.sensor_id);
    //           }
    //         })
    //         .catch((err) => {
    //           return err.response;
    //         });
    //       break;
    //     case "statusValve5":
    //       let data5 = {
    //         sensor_id: 514,
    //         status_manual: this.statusValve5,
    //       };
    //       // console.log(data5, "data");
    //       this.$API
    //         .put("sribun/statusmanual", data5)
    //         .then((res) => {
    //           if (res.status === 200) {
    //             this.statusValve5 = "pending";
    //             this.breakInterval = true;
    //             setTimeout(() => {
    //               this.getSensorById(data5.sensor_id);
    //               this.breakInterval = false;
    //             }, 300000);
    //             // this.getSensorById(data.sensor_id);
    //           }
    //         })
    //         .catch((err) => {
    //           return err.response;
    //         });
    //       break;
    //     case "statusValve6":
    //       let data6 = {
    //         sensor_id: 515,
    //         status_manual: this.statusValve6,
    //       };
    //     //  console.log (data6, "data");
    //       this.$API
    //         .put("sribun/statusmanual", data6)
    //         .then((res) => {
    //           if (res.status === 200) {
    //             this.statusValve6 = "pending";
    //             this.breakInterval = true;
    //             setTimeout(() => {
    //               this.getSensorById(data6.sensor_id);
    //               this.breakInterval = false;
    //             }, 300000);
    //             // this.getSensorById(data.sensor_id);
    //           }
    //         })
    //         .catch((err) => {
    //           return err.response;
    //         });
    //       break;
    //   }
    // },
    async getSensorById(id) {
      if (id) {
        try {
          let result = await this.$API.get(`sribun/sensor/status/${id}`);
          if (result.status === 200) {
            await this.checkStatus(result);
          }
        } catch (error) {
          // console.log(error);
        }
      }
    },
    async checkStatus(result) {
      switch (result.data.id) {
        case 1:
          if (result.data.status_manual === "on") this.statusValve1 = true;
          else if (result.data.status_manual === "off")
            this.statusValve1 = false;
          else this.statusValve1 = "pending";
          break;
        case 2:
          if (result.data.status_manual === "on") this.statusValve2 = true;
          else if (result.data.status_manual === "off")
            this.statusValve2 = false;
          else this.statusValve2 = "pending";
          break;
        case 3:
          if (result.data.status_manual === "on") this.statusValve3 = true;
          else if (result.data.status_manual === "off")
            this.statusValve3 = false;
          else this.statusValve3 = "pending";
          break;
        case 4:
          if (result.data.status_manual === "on") this.statusValve4 = true;
          else if (result.data.status_manual === "off")
            this.statusValve4 = false;
          else this.statusValve4 = "pending";
          break;
        case 5:
          if (result.data.status_manual === "on") this.statusValve5 = true;
          else if (result.data.status_manual === "off")
            this.statusValve5 = false;
          else this.statusValve5 = "pending";
          break;
        case 6:
          if (result.data.status_manual === "on") this.statusValve6 = true;
          else if (result.data.status_manual === "off")
            this.statusValve6 = false;
          else this.statusValve6 = "pending";
          break;
      }
    },
  },
};
</script>
